<template>
  <SvgIcon :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`" fill="currentColor" class="inline-block" :data-testid="name"/>
</template>

<script setup lang="ts">
const props = defineProps({
  name: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: '24',
  },
});

import account from 'assets/images/icons/account.svg?component';
import add from 'assets/images/icons/add.svg?component';
import add_circle from 'assets/images/icons/add_circle.svg?component';
import add_document_snippet from 'assets/images/icons/add_document_snippet.svg?component';
import add_image_snippet from 'assets/images/icons/add_image_snippet.svg?component';
import add_link_snippet from 'assets/images/icons/add_link_snippet.svg?component';
import add_note_snippet from 'assets/images/icons/add_note_snippet.svg?component';
import add_photo from '~/assets/images/icons/add_photo.svg?component';
import add_text_snippet from '~/assets/images/icons/add_text_snippet.svg?component';
import agenda from '~/assets/images/icons/agenda.svg?component';
import ai_button from '~/assets/images/icons/ai_button.svg?component';
import angle_down from 'assets/images/icons/angle_down.svg?component';
import angle_left from 'assets/images/icons/angle_left.svg?component';
import angle_right from 'assets/images/icons/angle_right.svg?component';
import angle_up from 'assets/images/icons/angle_up.svg?component';
import arrow_forward from 'assets/images/icons/arrow_forward.svg?component';
import arrow_outward from 'assets/images/icons/arrow_outward.svg?component';
import arrow_back from 'assets/images/icons/arrow_back.svg?component';
import arrow_drop_down from 'assets/images/icons/arrow_drop_down.svg?component';
import arrow_right from 'assets/images/icons/arrow_right.svg?component';
import attach from 'assets/images/icons/attach.svg?component';

import back from 'assets/images/icons/back.svg?component';

import calendar from 'assets/images/icons/calendar.svg?component';
import calendar_month from 'assets/images/icons/calendar_month.svg?component';
import check from 'assets/images/icons/check.svg?component';
import check_circle from 'assets/images/icons/check_circle.svg?component';
import check_circle_fill from 'assets/images/icons/check_circle_fill.svg?component';
import checked_box from 'assets/images/icons/checked_box.svg?component';
import circular_cancel from 'assets/images/icons/circular_cancel.svg?component';
import circular_info from 'assets/images/icons/circular_info.svg?component';
import classIcon from 'assets/images/icons/class.svg?component';
import close from 'assets/images/icons/close.svg?component';
import collaboration from 'assets/images/icons/collaboration.svg?component';
import content from 'assets/images/icons/content.svg?component';
import copy from 'assets/images/icons/copy.svg?component';
import courses from 'assets/images/icons/courses.svg?component';
import create_from_template from 'assets/images/icons/create_from_template.svg?component';

import dashboard from 'assets/images/icons/dashboard.svg?component';
import dnd from 'assets/images/icons/dnd.svg?component';
import dots from 'assets/images/icons/dots.svg?component';
import download from 'assets/images/icons/download.svg?component';
import draft from 'assets/images/icons/draft.svg?component';
import drag_indicator from 'assets/images/icons/drag_indicator.svg?component';

import edit from 'assets/images/icons/edit.svg?component';
import editor_loading from 'assets/images/icons/editor_loading.svg?component';
import editor_saved from 'assets/images/icons/editor_saved.svg?component';
import editor_unsaved from 'assets/images/icons/editor_unsaved.svg?component';
import error from 'assets/images/icons/error.svg?component';
import error_circle from 'assets/images/icons/error_circle.svg?component';
import expand from 'assets/images/icons/expand.svg?component';
import export_icon from 'assets/images/icons/export_icon.svg?component';
import external_file from 'assets/images/icons/external_file.svg?component';
import external_folder from 'assets/images/icons/external_folder.svg?component';
import eye from 'assets/images/icons/eye.svg?component';
import eye_off from 'assets/images/icons/eye_off.svg?component';

import file_add from 'assets/images/icons/file_add.svg?component';
import filter from 'assets/images/icons/filter.svg?component';
import fullscreen from 'assets/images/icons/fullscreen.svg?component';

import goal from 'assets/images/icons/goal.svg?component';

import help from 'assets/images/icons/help.svg?component';

import info_fill from 'assets/images/icons/info_fill.svg?component';
import info_outline from 'assets/images/icons/info_outline.svg?component';
import item_card_calendar_checked from 'assets/images/icons/item_card_calendar_checked.svg?component';
import item_card_calendar_month_tiny from 'assets/images/icons/item_card_calendar_month_tiny.svg?component';
import item_card_calendar_plus from 'assets/images/icons/item_card_calendar_plus.svg?component';
import item_card_one_snippet from 'assets/images/icons/item_card_one_snippet.svg?component';
import item_card_three_snippets from 'assets/images/icons/item_card_three_snippets.svg?component';
import item_card_timer from 'assets/images/icons/item_card_timer.svg?component';
import item_card_two_snippets from 'assets/images/icons/item_card_two_snippets.svg?component';
import item_card_visibility_off_tiny from 'assets/images/icons/item_card_visibility_off_tiny.svg?component';
import item_card_visibility_tiny from 'assets/images/icons/item_card_visibility_tiny.svg?component';

import library from 'assets/images/icons/library.svg?component';
import library_search from 'assets/images/icons/library_search.svg?component';
import link from 'assets/images/icons/link.svg?component';
import list from 'assets/images/icons/list.svg?component';
import loader from 'assets/images/icons/loader.svg?component';
import locked from 'assets/images/icons/locked.svg?component';

import menu_open from 'assets/images/icons/menu_open.svg?component';
import more from 'assets/images/icons/more.svg?component';
import more_time from 'assets/images/icons/more_time.svg?component';
import move_item from 'assets/images/icons/move_item.svg?component';
import move_to_period from 'assets/images/icons/move_to_period.svg?component';
import move_to_previous_period from 'assets/images/icons/move_to_previous_period.svg?component';

import note from 'assets/images/icons/note.svg?component';
import note_add from 'assets/images/icons/note_add.svg?component';

import objects from 'assets/images/icons/objects.svg?component';
import open_left_panel from 'assets/images/icons/open_left_panel.svg?component';
import open_new from 'assets/images/icons/open_new.svg?component';

import pause_fill from 'assets/images/icons/pause_fill.svg?component';
import person from 'assets/images/icons/person.svg?component';
import person_add from 'assets/images/icons/person_add.svg?component';
import person_admin from 'assets/images/icons/person_admin.svg?component';
import play_fill from 'assets/images/icons/play_fill.svg?component';
import play_outline from 'assets/images/icons/play_outline.svg?component';
import ppt_file from 'assets/images/icons/ppt_file.svg?component';
import present from 'assets/images/icons/present.svg?component';
import print from 'assets/images/icons/print.svg?component';

import qr_code from 'assets/images/icons/qr_code.svg?component';

import remove from 'assets/images/icons/remove.svg?component';
import remove_from_period from 'assets/images/icons/remove_from_period.svg?component';
import reply from 'assets/images/icons/reply.svg?component';
import retry from 'assets/images/icons/retry.svg?component';

import schedule from 'assets/images/icons/schedule.svg?component';
import search from 'assets/images/icons/search.svg?component';
import settings from 'assets/images/icons/settings.svg?component';
import snippet_attach from 'assets/images/icons/snippet_attach.svg?component';
import snippet_file from 'assets/images/icons/snippet_file.svg?component';
import snippet_image from 'assets/images/icons/snippet_image.svg?component';
import snippet_link from 'assets/images/icons/snippet_link.svg?component';
import snippet_text from 'assets/images/icons/snippet_text.svg?component';
import sort from 'assets/images/icons/sort.svg?component';
import sparkle from 'assets/images/icons/sparkle.svg?component';
import spreadsheet_file from 'assets/images/icons/spreadsheet_file.svg?component';
import students from 'assets/images/icons/students.svg?component';
import swap from 'assets/images/icons/swap.svg?component';
import sync from 'assets/images/icons/sync.svg?component';
import sync_warning from 'assets/images/icons/sync_warning.svg?component';
import sync_disabled from 'assets/images/icons/sync_disabled.svg?component';
import syncing from 'assets/images/icons/syncing.svg?component';

import teachino_t from 'assets/images/icons/teachino_t.svg?component';
import template from 'assets/images/icons/template.svg?component';
import text_field from 'assets/images/icons/text_field.svg?component';
import trash from 'assets/images/icons/trash.svg?component';
import tutorial from 'assets/images/icons/tutorial.svg?component';

import unchecked_box from 'assets/images/icons/unchecked_box.svg?component';

import verified from 'assets/images/icons/verified.svg?component';
import visibility from 'assets/images/icons/visibility.svg?component';
import visibility_off from 'assets/images/icons/visibility_off.svg?component';

import waiting from 'assets/images/icons/waiting.svg?component';
import warning from 'assets/images/icons/warning.svg?component';
import week from 'assets/images/icons/week.svg?component';
import week_five_days from 'assets/images/icons/week_five_days.svg?component';
import week_seven_days from 'assets/images/icons/week_seven_days.svg?component';
import save_as from 'assets/images/icons/save_as.svg?component';

const icons = {
  account,
  add,
  add_circle,
  add_document_snippet,
  add_image_snippet,
  add_link_snippet,
  add_note_snippet,
  add_photo,
  add_text_snippet,
  agenda,
  ai_button,
  //ai_sparkle,
  angle_down,
  angle_left,
  angle_right,
  angle_up,
  arrow_back,
  arrow_drop_down,
  arrow_forward,
  arrow_outward,
  arrow_right,
  //article,
  attach,
  back,
  //backspace,
  //bookmark,
  //bookmark_add,
  //bookmark_remove,
  calendar,
  calendar_month,
  //campaign,
  //category,
  check,
  //check_box_outline_blank,
  check_circle,
  check_circle_fill,
  checked_box,
  //checklist,
  //circle_cancel_fill,
  circular_cancel,
  circular_info,
  classIcon,
  close,
  //closeNote,
  collaboration,
  content,
  copy,
  courses,
  create_from_template,
  dashboard,
  dnd,
  //doc_file,
  dots,
  download,
  draft,
  //drag_handle,
  drag_indicator,
  edit,
  editor_loading,
  editor_saved,
  editor_unsaved,
  error,
  error_circle,
  expand,
  export_icon,
  external_file,
  external_folder,
  eye,
  eye_off,
  file_add,
  filter,
  fullscreen,
  //generic_file,
  goal,
  help,
  info_fill,
  info_outline,
  item_card_calendar_checked,
  item_card_calendar_month_tiny,
  item_card_calendar_plus,
  item_card_one_snippet,
  item_card_three_snippets,
  item_card_timer,
  item_card_two_snippets,
  item_card_visibility_off_tiny,
  item_card_visibility_tiny,
  library,
  library_search,
  link,
  list,
  loader,
  locked,
  //local_library,
  //mark_as_unread,
  menu_open,
  more,
  more_time,
  move_item,
  move_to_period,
  move_to_previous_period,
  note,
  note_add,
  objects,
  open_left_panel,
  open_new,
  pause_fill,
  //pdf_file,
  person,
  person_add,
  person_admin,
  play_fill,
  play_outline,
  ppt_file,
  present,
  print,
  qr_code,
  remove,
  //remove_calendar_item,
  remove_from_period,
  reply,
  retry,
  schedule,
  search,
  settings,
  snippet_attach,
  snippet_file,
  snippet_image,
  snippet_link,
  snippet_text,
  sort,
  sparkle,
  spreadsheet_file,
  students,
  swap,
  sync,
  syncing,
  sync_warning,
  sync_disabled,
  teachino_t,
  template,
  text_field,
  trash,
  tutorial,
  unchecked_box,
  verified,
  visibility,
  visibility_off,
  waiting,
  warning,
  week,
  week_five_days,
  week_seven_days,
};

const SvgIcon = icons[props.name];
</script>
